<template>
  <v-container fluid class="pa-4 rtl">
    <v-card class="header-card governance mb-4" elevation="2">
      <div class="d-flex align-center justify-space-between flex-wrap ga-3">
        <div>
          <div
            class="text-h5 font-weight-bold text-blue-darken-3"
            style="color: #4a4f55"
          >
            المشاركة المجتمعية وآليات المساءلة
          </div>
          <div class="text-body-2 text-grey-darken-1 mt-1">
            مستوى إشراك المجتمع وآليات استقبال الشكاوى
          </div>
        </div>

        <v-btn
          prepend-icon="mdi-arrow-right"
          variant="text"
          color="blue-darken-3"
          @click="showView('pillar-governance')"
        >
          رجوع
        </v-btn>
      </div>
    </v-card>

    <v-row class="mb-4">
      <v-col cols="12" sm="6" md="3"
        ><v-card class="kpi-card warning"
          ><div class="kpi-value">3/9</div>
          <div class="kpi-label">لديها لجنة صحية مجتمعية</div></v-card
        ></v-col
      >
      <v-col cols="12" sm="6" md="3"
        ><v-card class="kpi-card danger"
          ><div class="kpi-value">2/9</div>
          <div class="kpi-label">صناديق شكاوى فعّالة</div></v-card
        ></v-col
      >
      <v-col cols="12" sm="6" md="3"
        ><v-card class="kpi-card warning"
          ><div class="kpi-value">4/9</div>
          <div class="kpi-label">اجتماعات مجتمعية دورية</div></v-card
        ></v-col
      >
      <v-col cols="12" sm="6" md="3"
        ><v-card class="kpi-card danger"
          ><div class="kpi-value">22%</div>
          <div class="kpi-label">نساء في مجالس القرار</div></v-card
        ></v-col
      >
    </v-row>

    <v-card class="table-card" elevation="1">
      <div class="table-header">آليات المشاركة المجتمعية والمساءلة</div>

      <v-table class="custom-table">
        <thead>
          <tr>
            <th>المرفق</th>
            <th>لجنة صحية مجتمعية؟</th>
            <th>اجتماعات دورية؟</th>
            <th>صندوق شكاوى فعّال؟</th>
            <th>مشاركة المرضى في التقييم؟</th>
            <th>نسبة النساء في اللجان</th>
            <th>درجة المشاركة/100</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="item in facilities" :key="item.name">
            <td class="font-weight-bold">{{ item.name }}</td>
            <td>
              <v-chip
                :color="statusColor(item.communityCommittee)"
                size="small"
                variant="flat"
                >{{ item.communityCommittee }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="statusColor(item.periodicMeetings)"
                size="small"
                variant="flat"
                >{{ item.periodicMeetings }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="statusColor(item.complaintBox)"
                size="small"
                variant="flat"
                >{{ item.complaintBox }}</v-chip
              >
            </td>
            <td>{{ item.patientParticipation }}</td>
            <td class="font-weight-bold">{{ item.womenRate }}</td>
            <td
              class="font-weight-bold"
              :class="scoreClass(item.participationScore)"
            >
              {{ item.participationScore }}
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-card>
  </v-container>
</template>

<script setup>
const facilities = [
  {
    name: "مستشفى الصداقة التعليمي",
    communityCommittee: "لا",
    periodicMeetings: "لا",
    complaintBox: "نعم",
    patientParticipation: "ضعيف",
    womenRate: "18%",
    participationScore: 35,
  },
  {
    name: "مستشفى الأمراض النفسية",
    communityCommittee: "لا",
    periodicMeetings: "لا",
    complaintBox: "لا",
    patientParticipation: "لا يوجد",
    womenRate: "10%",
    participationScore: 15,
  },
  {
    name: "مجمع الشيخ عثمان",
    communityCommittee: "نعم",
    periodicMeetings: "نعم",
    complaintBox: "نعم",
    patientParticipation: "متوسط",
    womenRate: "40%",
    participationScore: 68,
  },
  {
    name: "مركز كود العثماني",
    communityCommittee: "جزئي",
    periodicMeetings: "نعم",
    complaintBox: "لا",
    patientParticipation: "متوسط",
    womenRate: "55%",
    participationScore: 55,
  },
  {
    name: "مركز الممدارة",
    communityCommittee: "نعم",
    periodicMeetings: "نعم",
    complaintBox: "نعم",
    patientParticipation: "جيد",
    womenRate: "60%",
    participationScore: 75,
  },
  {
    name: "مركز المحاريق",
    communityCommittee: "لا",
    periodicMeetings: "لا",
    complaintBox: "لا",
    patientParticipation: "لا يوجد",
    womenRate: "30%",
    participationScore: 20,
  },
  {
    name: "مركز عبد القوي",
    communityCommittee: "نعم",
    periodicMeetings: "نعم",
    complaintBox: "لا",
    patientParticipation: "متوسط",
    womenRate: "45%",
    participationScore: 65,
  },
  {
    name: "مركز ماري ستبوس",
    communityCommittee: "لا",
    periodicMeetings: "لا",
    complaintBox: "لا",
    patientParticipation: "لا يوجد",
    womenRate: "0%",
    participationScore: 10,
  },
  {
    name: "جمعية حقوق الطفل",
    communityCommittee: "جزئي",
    periodicMeetings: "نعم",
    complaintBox: "لا",
    patientParticipation: "متوسط",
    womenRate: "85%",
    participationScore: 60,
  },
];

const statusColor = (value) => {
  if (value === "نعم") return "green";
  if (value === "جزئي") return "orange";
  return "red";
};

const scoreClass = (value) => {
  if (value >= 70) return "text-green-darken-2";
  if (value >= 40) return "text-orange-darken-2";
  return "text-red-darken-2";
};

const showView = (view) => console.log("Go to:", view);
</script>

<style scoped>
.rtl {
  direction: rtl;
}

.header-card {
  border-radius: 18px;
  padding: 20px;
}

.header-card.governance {
  border-right: 5px solid #4a4f55;
}

.kpi-card {
  border-radius: 18px;
  padding: 20px;
  text-align: center;
}

.kpi-value {
  font-size: 34px;
  font-weight: 800;
}

.kpi-label {
  margin-top: 6px;
  font-size: 13px;
}

.danger {
  background: #fdecea;
  color: #c0392b;
}

.warning {
  background: #fff4e5;
  color: #d4821a;
}

.table-card {
  border-radius: 18px;
  overflow: hidden;
}

.table-header {
  padding: 18px;
  font-size: 18px;
  font-weight: 700;
  border-bottom: 1px solid #eee;
}

.custom-table {
  direction: rtl;
}

:deep(th) {
  font-weight: 800 !important;
  color: #1a2332 !important;
  white-space: nowrap;
}

:deep(td) {
  font-size: 14px;
  white-space: nowrap;
}
</style>
